"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.make = exports.makePathFragments = void 0;
const container_1 = require("../../node/container");
const util_1 = require("../../util");
const common_1 = require("./common");
const makePathFragments = (container, childFragments) => {
    if (!container.parent || container.type === container_1.ContainerType.ROOT) {
        return childFragments;
    }
    else if (container.type === container_1.ContainerType.TOPLEVEL) {
        if (container.el.tag === "MainProvision" && childFragments.length > 0) {
            return (0, exports.makePathFragments)(container.parent, childFragments);
        }
        const alias = (Object.entries(common_1.topLevelAlias).find(([, value]) => value === container.el.tag) ?? [container.el.tag])[0];
        if (((container.el.tag === "SupplProvision") &&
            !("AmendLawNum" in container.el.attr) &&
            (container.parent.children.filter(c => c.el.tag === container.el.tag && !("AmendLawNum" in c.el.attr)).length === 1)) ||
            (!("Num" in container.el.attr) &&
                (container.parent.children.filter(c => c.el.tag === container.el.tag && !("Num" in c.el.attr)).length === 1))) {
            const fragment = {
                type: "TOPLEVEL",
                text: alias,
                tag: container.el.tag,
                num: null,
                attr: [],
                nth: null,
            };
            return (0, exports.makePathFragments)(container.parent, [fragment, ...childFragments]);
        }
        else {
            let num = null;
            const attr = [];
            let nth = null;
            if ("Num" in container.el.attr) {
                num = container.el.attr.Num ?? "";
            }
            else if ("AmendLawNum" in container.el.attr) {
                attr.push({ key: "AmendLawNum", value: container.el.attr.AmendLawNum ?? "" });
            }
            else {
                nth = (container.parent.children.filter(c => c.el.tag === container.el.tag).indexOf(container) + 1).toString();
            }
            const modifier = ((num !== null)
                ? `=${num}`
                : (attr.length !== 0)
                    ? attr.map(({ key, value }) => `[${key}="${value}"]`).join("")
                    : `[${nth}]`);
            const fragment = {
                type: "TOPLEVEL",
                text: `${alias}${modifier}`,
                tag: container.el.tag,
                num,
                attr,
                nth,
            };
            return (0, exports.makePathFragments)(container.parent, [fragment, ...childFragments]);
        }
    }
    else if (container.type === container_1.ContainerType.ARTICLES) {
        let num = null;
        let nth = null;
        if ("Num" in container.el.attr) {
            num = container.el.attr.Num ?? "";
        }
        else {
            nth = (container.parent.children.filter(c => c.el.tag === container.el.tag).indexOf(container) + 1).toString();
        }
        const modifier = ((num !== null)
            ? `=${num}`
            : `[${nth}]`);
        const fragment = {
            type: "ARTICLES",
            text: `${container.el.tag}${modifier}`,
            tag: container.el.tag,
            num,
            attr: [],
            nth,
        };
        return (0, exports.makePathFragments)(container.parent, [fragment, ...childFragments]);
    }
    else if (container.type === container_1.ContainerType.SENTENCES) {
        if (!container.subParent)
            return childFragments;
        const alias = (Object.entries(common_1.sentencesContainerAlias).find(([, value]) => value === container.el.tag) ?? [container.el.tag])[0];
        let num = null;
        let nth = null;
        if ("Num" in container.el.attr) {
            num = container.el.attr.Num ?? "";
        }
        else {
            nth = (container.subParent.subChildren.filter(c => c.el.tag === container.el.tag).indexOf(container) + 1).toString();
        }
        const modifier = ((num !== null)
            ? `=${num}`
            : `[${nth}]`);
        const fragment = {
            type: "SENTENCES",
            text: `${alias}${modifier}`,
            tag: container.el.tag,
            num,
            attr: [],
            nth,
        };
        return (0, exports.makePathFragments)((((container.subParent.el.tag === "Paragraph") &&
            (container.subParent.subParent) &&
            (container.subParent.subParent.subChildren.length === 1))
            ? container.subParent.subParent
            : container.subParent), [fragment, ...childFragments]);
    }
    else {
        throw (0, util_1.assertNever)(container.type);
    }
};
exports.makePathFragments = makePathFragments;
const make = (container) => {
    const fragments = (0, exports.makePathFragments)(container, []);
    return fragments.map(f => f.text).join("/");
};
exports.make = make;
exports.default = exports.make;
//# sourceMappingURL=make.js.map